var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pl-18 pr-18" }, [
    _c("div", { staticClass: "pt-2" }, [
      _c("div", { staticClass: "block-row ex-heading" }, [
        _c("label", { staticClass: "row-lb font500" }, [
          _vm._v(_vm._s(_vm.$t("tour.tour_name")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row-cnt mr-2" }, [
          _vm._v(
            "\n                " + _vm._s(_vm.tourInfo.name) + "\n            "
          )
        ]),
        _vm._v(" "),
        _vm._m(0)
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "collapse mb-4", attrs: { id: "tourInfor" } },
      [
        _c("BizPrePaidCard", {
          attrs: {
            selectedBizPrePaidCard: _vm.selectedBizPrePaidCard,
            showUseBizPrePaidCard: _vm.showUseBizPrePaidCard
          },
          on: { updateBizPrePaidCard: _vm.updateBizPrePaidCard }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "detail-block box-info" }, [
          _c("div", { staticClass: "block-row" }, [
            _c("label", { staticClass: "row-lb font500" }, [
              _vm._v(_vm._s(_vm.$t("tour.tour_number")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row-cnt" }, [
              _vm._v(_vm._s(_vm.tourInfo.tour_number))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "block-row" }, [
            _c("label", { staticClass: "row-lb font500" }, [
              _vm._v(_vm._s(_vm.$t("tour.departure_date")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row-cnt" }, [
              _vm._v(
                _vm._s(
                  _vm.dateUtils.formatDateYYYYMMDD(_vm.tourInfo.departure_date)
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "block-row" }, [
            _c("label", { staticClass: "row-lb font500" }, [
              _vm._v(_vm._s(_vm.$t("tour.return_date")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row-cnt" }, [
              _vm._v(
                _vm._s(
                  _vm.dateUtils.formatDateYYYYMMDD(_vm.tourInfo.return_date)
                )
              )
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-expand-detail ml-auto p-0",
        attrs: {
          "data-toggle": "collapse",
          "data-target": "#tourInfor",
          "aria-expanded": "false"
        }
      },
      [_c("i", { staticClass: "icon-expand" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11428ffc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11428ffc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/Tour/Info.vue
// module id = null
// module chunks = 